<div class="loader-overlay" *ngIf="show">
  <div class="alerts text-center loader-align">
    <img src="../../assets/image/loader.gif" height="50" width="50" />
  </div>
</div>